import { Injectable } from '@angular/core';
import { CreateCommandHandler } from '../../../core/service/command/create-command-handler.service';
import { DeleteFormCommandHandler } from '../../../core/service/command/delete-form-command-handler.service';
import { FormCommandHandlerResolver } from '../../../core/service/command/form-command-handler-resolver.service';

@Injectable()
export class LettingFeatureFormCommandHandlerResolver extends FormCommandHandlerResolver {
  constructor(createHandler: CreateCommandHandler, deleteHandler: DeleteFormCommandHandler) {
    super(createHandler, deleteHandler);
  }
}
